import React from "react";
import AuthGuard from "../../../components/shared/AuthGuard";
import ConversationList from "./ConversationList";
import ChatWindow from "./ChatWindow";
import ContextSidebar from "./ContextSidebar";
import "./ChatPage.css";

const ChatPage = () => {
  return (
    <AuthGuard
      feature="Chat"
      message="Bạn cần đăng nhập để trò chuyện"
      showLockIcon={true}
      blurContent={true}
    >
      <div className="chat-layout">
        <ConversationList />
        <ChatWindow />
        <ContextSidebar />
      </div>
    </AuthGuard>
  );
};

export default ChatPage;
